import React from 'react';
import { testimonials } from '../data/content';
export function Testimonials() {
  return <section className="w-full bg-white px-5 py-20 sm:py-28" data-id="element-171" data-mp="3kpugtgqsmnhi">
      <div className="mx-auto max-w-5xl" data-id="element-172" data-mp="3ksgwy4rr2bbc">
        <h2 className="text-center font-display text-[2rem] font-extrabold uppercase leading-tight text-ink sm:text-[2.8rem]" data-id="element-173" data-mp="3fyvxs9ef7bak">
          What Coaches Are Saying
        </h2>
        <p className="mt-3 text-center text-sm font-medium text-ink/70" data-id="element-174" data-mp="36yzgwty9vgq2">
          <span aria-hidden="true" data-id="element-175" data-mp="36wwfldro6161">⭐️⭐️⭐️⭐️⭐️</span> 4.9/5 · +2,000 Coaches
        </p>

        <div className="mx-auto mt-10 grid max-w-5xl gap-5 md:grid-cols-3" data-id="element-176" data-mp="31ybhbjvz9rk8">
          {testimonials.map(item => <figure key={item.name} className="flex h-full flex-col rounded-2xl border border-ink/5 bg-chalk p-6" data-id="element-177" data-mp="2x2w5sylg07qz">
              <div className="text-sm text-lime-dark" aria-label="5 out of 5 stars" data-id="element-178" data-mp="v8dmppcdwidz">
                <span aria-hidden="true" data-id="element-179" data-mp="q893hrk3d9k2">★ ★ ★ ★ ★</span>
              </div>
              <blockquote className="mt-4 flex-1 text-sm leading-relaxed text-ink/85" data-id="element-180" data-mp="h55aw37q1xxm">
                &ldquo;{item.quote}&rdquo;
              </blockquote>
              <figcaption className="mt-6" data-id="element-181" data-mp="780l7teo3kc2">
                <p className="text-xs font-bold text-ink" data-id="element-182" data-mp="79bntpwdmm1l">{item.name}</p>
                <p className="text-xs text-ink/50" data-id="element-183" data-mp="c624aec3fjnj">{item.location}</p>
              </figcaption>
            </figure>)}
        </div>

        <p className="mt-8 text-center text-[11px] text-ink/40" data-id="element-184" data-mp="zx7qrccjha6t">
          Illustrative placeholder testimonials.
        </p>
      </div>
    </section>;
}